import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=2df89caa&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=2df89caa&lang=scss&scoped=true&"
import style2 from "./ForgotPassword.vue?vue&type=style&index=2&id=2df89caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df89caa",
  null
  
)

export default component.exports